/**
 * Het live verslag is een schermvullende pagina met een eigen kop, een eigen actiebalk onderin
 * en een eigen verbindingsindicator. De onderbalk en de offline-melding van de rest van de app
 * blijven daar weg; beide lezen dit patroon.
 *
 * nginx.conf.template heeft voor dit pad een eigen location-blok.
 */
export const LIVE_ROUTE_PATTERN = /^\/coach\/wedstrijden\/[^/]+\/live\/?$/;

export const isLiveRoute = (pathname: string): boolean => LIVE_ROUTE_PATTERN.test(pathname);

export const liveRoutePath = (matchId: number | string): string => `/coach/wedstrijden/${matchId}/live`;
